import SurveyMenu from "./SurveyMenu";

export default SurveyMenu;
